import { render, staticRenderFns } from "./UserWishlistForm.vue?vue&type=template&id=2d2619b9&"
import script from "./UserWishlistForm.vue?vue&type=script&lang=js&"
export * from "./UserWishlistForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports